import React from 'react';
import classNames from 'classnames';
import Survey from '../platformui/Survey';

export default function SurveyBlock(props) {
  const classes = classNames({
    'c-survey-content__item': true,
    'c-intro-content__item': props.PropertyName === 'IntroContent',
  });
  const containerClasses = classNames({
    'c-survey__container': true,
    'c-intro-content__item__container': props.PropertyName === 'IntroContent',
  });

  const site = props.CurrentPageProps.Site;

  return (
    <div className={classes}>
      <div className={containerClasses}>
        <Survey
          {...props}
          resultMeterColors={site === 'rhb' ? ['#16626a'] : ['#007eb0']}
        />
      </div>
    </div>
  );
}